import { storyblokEditable } from "gatsby-source-storyblok"

import ArticleFilterSection from "../../../V2/Sections/ArticleFilterSection"

import React from "react"

const StoryblokArticleFilterSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ArticleFilterSection>) => {
  return (
    <ArticleFilterSection
      callout={blok.callout?.[0]}
      superscriptText={blok.superscriptText || undefined}
      headingText={blok.headingText || undefined}
      highlightedText={blok.highlightedText || undefined}
      headingBodyText={blok.headingBodyText || undefined}
      searchPlaceholder={blok.searchPlaceholder || undefined}
      allTabLabel={blok.allTabLabel || undefined}
      sortLabel={blok.sortLabel || undefined}
      latestOptionLabel={blok.latestOptionLabel || undefined}
      applyFilterText={blok.applyFilterText || undefined}
      loadMoreText={blok.loadMoreText || undefined}
      useInternalItems={blok.useInternalItems}
      initialNumArticles={blok.initialNumArticles || undefined}
      emptyStateText={blok.emptyStateText || undefined}
      textColor={blok.textColor || undefined}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokArticleFilterSection
